import { render, staticRenderFns } from "./DetalheDRE.vue?vue&type=template&id=305f1282&scoped=true"
import script from "./DetalheDRE.vue?vue&type=script&lang=js"
export * from "./DetalheDRE.vue?vue&type=script&lang=js"
import style0 from "./DetalheDRE.vue?vue&type=style&index=0&id=305f1282&prod&lang=scss&scoped=true"
import style1 from "./DetalheDRE.vue?vue&type=style&index=1&id=305f1282&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "305f1282",
  null
  
)

export default component.exports